import { useState } from 'react';
import { Icon } from '../';
import { IMedia } from '../../../types/model';

export const ImageSlider = ({ images }: { images: IMedia[] }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  const handleBackClick = () => {
    if (selectedImage > 0) {
      setSelectedImage(selectedImage - 1);
    }
  };

  const handleForwardClick = () => {
    if (selectedImage < images.length - 1) {
      setSelectedImage(selectedImage + 1);
    }
  };

  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex items-center justify-between w-full">
        {images.length > 1 && (
          <Icon
            svgName="navigateBefore"
            className="h-5 w-5 cursor-pointer"
            onClick={handleBackClick}
          />
        )}
        {images[selectedImage] ? (
          <div className="flex mx-10 max-h-110 w-full bg-grey-30 rounded-xl overflow-hidden">
            <img
              src={images[selectedImage].size?.preview}
              alt={'image-slide-' + selectedImage}
              className={'mx-auto'}
            />
          </div>
        ) : (
          <div className="flex w-full h-60 bg-grey-30 rounded-xl" />
        )}
        {images.length > 1 && (
          <Icon
            svgName="navigateNext"
            className="h-5 w-5 cursor-pointer"
            onClick={handleForwardClick}
          />
        )}
      </div>
      <div className="flex gap-3 mt-4">
        {images.map((_, index) => (
          <div
            key={`image_slide_${index}`}
            className={`flex w-1.5 h-1.5 rounded-full cursor-pointer ${
              index === selectedImage ? 'bg-primary' : 'bg-grey-10'
            }`}
            onClick={() => setSelectedImage(index)}
          />
        ))}
      </div>
    </div>
  );
};
